import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { XaltDateField } from 'xalt-react-atoms';
import RWFieldAction from './RWFieldAction';

/**
 * A platform component for building a client action
 */
class RWFieldActionDatePicker extends PureComponent {
    static propTypes = {
        style: PropTypes.object,
        action: PropTypes.object,
        onFieldAction: PropTypes.func,
        value: PropTypes.instanceOf(Date),
        firstDayOfWeek: PropTypes.number,
    };

    constructor(props) {
        super(props);
        this.handleOnActionClick = this.handleOnActionClick.bind(this);
        this.datePickerRef = React.createRef();
    }

    render() {
        const {
            value,
            firstDayOfWeek,
            ...restProps } = this.props;

        const standardActionPrps = {
            ...restProps,
            onFieldAction: this.handleOnActionClick, // override standard action click
        };

        return (
            <>
                <RWFieldAction { ...standardActionPrps } />
                <XaltDateField
                    style={ { visibility: 'hidden', width: '0px' } }
                    inputRef={ this.datePickerRef }
                    firstDayOfWeek={ firstDayOfWeek }
                    onValueChanged={ this.handleOnChange }
                    value={ value } />
            </>
        );
    }

    handleOnChange = (date) => {
        const { action } = this.props;
        const { clientFunction } = action;
        if (clientFunction) {
            clientFunction(date);
        }
    };

    handleOnActionClick(event) {
        if (this.datePickerRef && this.datePickerRef.current) {
            this.datePickerRef.current.click(event);
        }
    }
}

export default RWFieldActionDatePicker;
